import React from "react";
import { Step, Icon } from "semantic-ui-react";
import _ from 'lodash'

let menu = [
    { key: "basicInfo", name: "Summary", icon: 'edit', disabled: false, color: 'grey' },
    { key: "AdditionlInfo", name: "Custom Attribute", icon: 'list', disabled: false, color: 'grey' },
    { key: "teamMapping", name: "Role Mapping", icon: 'users', disabled: false, color: 'grey' },
    { key: "configureActivity", name: "Activities", icon: 'th list', disabled: false, color: 'grey' },
    // { key: "integration", name: "Integration", icon: 'exchange', disabled: false, color: 'grey' },
    { key: "finalize", name: "Timeline", icon: 'calendar check', disabled: false, color: 'grey' },
    { key: "review", name: "Review & Start", icon: 'check square', disabled: false, color: 'grey' },
]


class CreateInitiativeSteps extends React.Component {
    render() {


        let checkSchema = (this.props.selectedPlaybookData &&
            this.props.selectedPlaybookData.metaDataSchema &&
            this.props.selectedPlaybookData.metaDataSchema.length !== 0) ||
            this.props.selectedDataById &&
            this.props.selectedDataById.practiceId &&
            this.props.selectedDataById.practiceId.metaDataSchema &&
            this.props.selectedDataById.practiceId.metaDataSchema.length !== 0


        return (
            <div className="w_100">
                <Step.Group size='mini' fluid className="initiative_steps" >
                    {menu.map((item, index) => {
                        return item.key !== 'AdditionlInfo' || (item.key === 'AdditionlInfo' && checkSchema) ? <Step key={index} disabled={this.props.match.params.initiativeId ? false : true} active={item.key === this.props.setPage} >
                            <Icon name={item.icon} color={item.color} />
                            <Step.Content >
                                <Step.Title>{item.name} </Step.Title>
                            </Step.Content>
                        </Step> : null
                    })}

                </Step.Group>
            </div>
        );
    }
}
export default CreateInitiativeSteps;
